import { useMemo } from 'react';
import { Layer, Source, type SourceProps } from 'react-map-gl/mapbox';

import type { GeoJSON } from 'geojson';

type Props = {
  color: string;
  geoJSON: GeoJSON;
  id: string;
};

export function GeoJSONLayer({ color, geoJSON, id }: Props): JSX.Element {
  const source: SourceProps = useMemo(() => {
    return {
      data: geoJSON,
      id: `${id}_geoJSON`,
      type: 'geojson'
    };
  }, [geoJSON, id]);

  return (
    <Source key={`${id}_geoJSON`} {...source}>
      <Layer
        id={`layer_${id}`}
        key={`layer_${id}`}
        paint={{
          'fill-color': color,
          'fill-opacity': 0.3
        }}
        type="fill"
      />
      <Layer
        id={`layer_${id}_line`}
        key={`layer_${id}_line`}
        paint={{
          'line-color': color,
          'line-opacity': 0.6,
          'line-width': 2
        }}
        type="line"
      />
    </Source>
  );
}
